const rock_truck_header = [
			{ title: "Tires, wheels, stem caps", description: "Inflation, leaks, damage, wear" },
			{ title: "Duo-cone seal area", description: "Damage, leaks" },
			{ title: "Underneath machine", description: "Leaks, damage" },
			{ title: "Differentials, brakes, transmission", description: "Leaks" },
			{ title: "Front suspension cylinders", description: "Leaks, proper cylinder height" },
			{ title: "Engine area", description: "Leaks, damage, belt/hose condition" },
			{ title: "Engine oil", description: "Fluid level (record oil additions if equipped with oil renewal system" },
			{ title: "Fuel filters/water separator", description: "Leaks/drain water (if equipped)" },
			{ title: "Fuel tank", description: "Mounting brackets, welds, leaks, drain water and sediment" },
			{ title: "Hoist cylinders", description: "Wear, damage, leaks" },
			{ title: "Dump body and truck frame", description: "Damage, wear, distortion, presence of frame and body support pads" },
			{ title: "Rear tire rock ejectors", description: "Free movement" },
			{ title: "Primary air tank", description: "Drain moisture" },
			{ title: "Steps and handholds", description: "Condition and cleanliness" },
			{ title: "Torque converter case", description: "Transmission and torque converter fluid level, damage, leaks" },
			{ title: "Hoist, converter, and brake oil tank", description: "Fluid level, damage, leaks" },
			{ title: "Steering oil tank", description: "Fluid level, damage, leaks" },
			{ title: "Transmission oil tank", description: "Fluid level, damage, leaks" },
			{ title: "Steps, handholds", description: "Condition and cleanliness" },
			{ title: "Lights, front and rear", description: "Function, damage to lens, housing, or wiring" },
			{ title: "Radiator", description: "Debris between radiator and grill, fin blockage, leaks" },
			{ title: "ROPS", description: "Damage, loose mounting bolts" },
			{ title: "Engine oil", description: "Fluid level (record oil additions if equipped with oil renewal system)" },
			{ title: "Engine coolant", description: "Fluid level (jacket water, after-cooler)" },
			{ title: "Radiator", description: "Fin blockage, leaks" },
			{ title: "All hoses", description: "Cracks, wear spots, leaks" },
			{ title: "All belts", description: "Tension, wear, cracks" },
			{ title: "Overall engine compartment", description: "Trash or dirt buildup, leaks" },
			{ title: "Handholds", description: "Condition, cleanliness" },
			{ title: "Mirrors", description: "Damage, adjust for best visibility" },
			{ title: "ROPS", description: "Damage, loose mounting bolts" },
			{ title: "Dump body above platform", description: "Damage, wear, distortion" },
			{ title: "Pre-cleaner", description: "Debris" },
			{ title: "Air filter", description: "Restriction indicator, dust valves unplugged" },
			{ title: "Steering oil tank", description: "Fluid level, damage, leaks" },
			{ title: "Fire extinguisher", description: "Charge, damage" },
			{ title: "Windshield, windows", description: "Broken glass, cleanliness" },
			{ title: "Windshield wipers / washers", description: "Wear, damage/fluid level" },
			{ title: "Doors", description: "Open properly, broken glass" },
			{ title: "Air conditioner filter", description: "Dirt, dust" },
			{ title: "Primary air tank", description: "Drain moisture" },
			{ title: "Secondary air tank", description: "Drain" },
			{ title: "Battery compartment", description: "Cleanliness, loose nuts & bolts" },
			{ title: "Seat", description: "Adjustment, able to reach pedals" },
			{ title: "Seat belt and mounting", description: "Damage, wear, adjustment, age" },
			{ title: "Horn, backup alarm, lights", description: "Proper function" },
			{ title: "Mirrors", description: "Damage, adjust for best visibility" },
			{ title: "Recirculation cab air filter", description: "Dirt, dust" },
			{ title: "Gauges, indicators, switches, controls", description: "Damage, function" },
			{ title: "Overall cab interior", description: "Cleanliness" },
		]

export default rock_truck_header;